export const indianCities = [
  'Aalo',
  'Abohar',
  'Abu Road',
  'Achampet',
  'Acharapakkam',
  'Addanki',
  'Adilabad',
  'Adimali',
  'Adipur',
  'Adoni',
  'Agar Malwa',
  'Agartala',
  'Agiripalli',
  'Agra',
  'Ahilyanagar (Ahmednagar)',
  'Ahmedabad',
  'Ahmedgarh',
  'Ahore',
  'Aizawl',
  'Ajmer',
  'Akaltara',
  'Akbarpur',
  'Akividu',
  'Akluj',
  'Akola',
  'Akot',
  'Alakode',
  'Alangudi',
  'Alangulam',
  'Alappuzha',
  'Alathur',
  'Alibaug',
  'Aligarh',
  'Alipurduar',
  'Allagadda',
  'Almora',
  'Alwar',
  'Ambala',
  'Amravati',
  'Amritsar',
  'Anand',
  'Anantapur',
  'Asansol',
  'Aurangabad',
  'Ayodhya',
  'Balasore',
  'Ballari',
  'Balurghat',
  'Bankura',
  'Bareilly',
  'Batala',
  'Bathinda',
  'Belagavi',
  'Bengaluru',
  'Berhampore',
  'Berhampur',
  'Bhagalpur',
  'Bharatpur',
  'Bharuch',
  'Bhavnagar',
  'Bhilai',
  'Bhilwara',
  'Bhiwani',
  'Bhopal',
  'Bhubaneswar',
  'Bhuj',
  'Bidar',
  'Bikaner',
  'Bilaspur',
  'Bokaro',
  'Chandigarh',
  'Chennai',
  'Coimbatore',
  'Cooch Behar',
  'Cuddalore',
  'Cuttack',
  'Darbhanga',
  'Darjeeling',
  'Davanagere',
  'Dehradun',
  'Delhi',
  'Delhi-NCR',
  'Deoghar',
  'Dewas',
  'Dhanbad',
  'Dharamshala',
  'Dibrugarh',
  'Durg',
  'Durgapur',
  'Erode',
  'Faridabad',
  'Gandhinagar',
  'Gangtok',
  'Gaya',
  'Ghaziabad',
  'Gorakhpur',
  'Guntur',
  'Gurugram',
  'Guwahati',
  'Gwalior',
  'Haldwani',
  'Haridwar',
  'Hassan',
  'Hazaribagh',
  'Hisar',
  'Hoshiarpur',
  'Howrah',
  'Hubballi',
  'Hyderabad',
  'Imphal',
  'Indore',
  'Itanagar',
  'Jabalpur',
  'Jaipur',
  'Jalandhar',
  'Jalgaon',
  'Jalpaiguri',
  'Jammu',
  'Jamnagar',
  'Jamshedpur',
  'Jhansi',
  'Jodhpur',
  'Jorhat',
  'Kakinada',
  'Kalaburagi',
  'Kalyani',
  'Kannur',
  'Kanpur',
  'Karnal',
  'Khandwa',
  'Kishangarh',
  'Kochi',
  'Kohima',
  'Kolhapur',
  'Kolkata',
  'Kollam',
  'Kota',
  'Kottayam',
  'Kozhikode',
  'Kurnool',
  'Latur',
  'Leh',
  'Lucknow',
  'Ludhiana',
  'Madurai',
  'Malappuram',
  'Malda',
  'Manali',
  'Mangaluru',
  'Margao',
  'Mathura',
  'Meerut',
  'Mehsana',
  'Mohali',
  'Moradabad',
  'Morbi',
  'Mumbai',
  'Muzaffarnagar',
  'Muzaffarpur',
  'Mysuru',
  'Nadiad',
  'Nagpur',
  'Nanded',
  'Nashik',
  'Navi Mumbai',
  'Nellore',
  'Noida',
  'Palakkad',
  'Palampur',
  'Panaji',
  'Panchkula',
  'Panipat',
  'Pathankot',
  'Patiala',
  'Patna',
  'Pondicherry',
  'Prayagraj',
  'Pune',
  'Puri',
  'Purnea',
  'Raipur',
  'Rajamahendravaram',
  'Rajkot',
  'Ranchi',
  'Ratlam',
  'Rewa',
  'Rishikesh',
  'Rohtak',
  'Rourkela',
  'Sagar',
  'Salem',
  'Sambalpur',
  'Sangli',
  'Satara',
  'Satna',
  'Shillong',
  'Shimla',
  'Shivamogga',
  'Sikar',
  'Silchar',
  'Siliguri',
  'Solapur',
  'Srinagar',
  'Surat',
  'Thane',
  'Thanjavur',
  'Thiruvananthapuram',
  'Thoothukudi',
  'Thrissur',
  'Tinsukia',
  'Tiruchirappalli',
  'Tirunelveli',
  'Tirupati',
  'Tiruppur',
  'Tumakuru',
  'Udaipur',
  'Udupi',
  'Ujjain',
  'Vadodara',
  'Valsad',
  'Vapi',
  'Varanasi',
  'Vellore',
  'Vijayawada',
  'Visakhapatnam',
  'Yamunanagar'
];